import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose
} from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'lfw-form-not-found-dialog',
  templateUrl: './form-not-found-dialog.component.html',
  styleUrls: ['./form-not-found-dialog.component.css'],
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, TranslatePipe]
})
export class FormNotFoundDialogComponent {
  title!: string;
  message!: string;

  constructor(
    public dialogRef: MatDialogRef<FormNotFoundDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
}
